/**
 * Mixin for registered additional modules in the Swiper component. This mixin provides the necessary
 */

import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'
export default {
  data () {
    return {
      Navigation: null,
      Pagination: null,
      Autoplay: null,
      EffectFade: null
    }
  },

  created () {
    this.Navigation = Navigation
    this.Pagination = Pagination
    this.Autoplay = Autoplay
    this.EffectFade = EffectFade
  },
  computed: {
    autoplayOptions () {
      return this.autoplay ? { delay: this.delayInSeconds * 1000 } : false
    },
    signageAutoplay () {
      return this.hasMultiSlides ? { delay: this.interval } : false
    },
    showtimeAutoplay () {
      return this.sliderAutoplay ? { delay: this.sliderDelayInSeconds * 1000 } : false
    }
  }
}
